/* unplugin-vue-components disabled */import { render } from "./ImageUpload.vue?vue&type=template&id=0df0cc4e"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\zjsl_project\\garden-h5-car\\garden-car\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.47+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__